import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QrcodeService {

  public qrdata: any[] = [];

  constructor() { }

}
